import {useLayoutEffect,useRef} from 'react';
import type {Snapshot} from '@platform/contracts/x';
import {money} from '@platform/client';
import {useCopy,useUi} from '@platform/ui/config';
import {LiveScene} from './RoomLive';
import {PurchasePrizeGuide} from './PurchasePrizeGuide';
import {RoomControls} from './RoomControls';
import {RoomMenu,type RoomDestination} from './RoomMenu';

type AccountHeaderProps={wallet:Snapshot;connected:boolean;sound:boolean;onSound:(sound:boolean)=>void;onNavigate:(destination:RoomDestination)=>void};
export function RoomAccountHeader({wallet,connected,sound,onSound,onNavigate}:AccountHeaderProps){
 const t=useCopy(),ui=useUi(),ref=useRef<HTMLElement>(null);
 useLayoutEffect(()=>{
  const header=ref.current;if(!header)return;
  const root=header.closest<HTMLElement>('.next-round-purchase')??document.documentElement;
  const update=()=>root.style.setProperty('--room-header-height',header.getBoundingClientRect().height+'px');
  update();const observer=new ResizeObserver(update);observer.observe(header);
  return()=>{observer.disconnect();root.style.removeProperty('--room-header-height');};
 },[]);
 return <header ref={ref} className="room-topbar">
  <a className="room-brand" href={ui.links.tombala} aria-label={t('brand.home')}><span className="brand-symbol">{t('brand.number')}<span>°</span></span></a>
  <h1>{t('room.title')}</h1>
  <span className={'connection '+(connected?'online':'')} role="img" aria-label={t(connected?'connection.online':'connection.pending')} title={t(connected?'connection.online':'connection.pending')}/>
  <div className="room-balance" aria-label={t('wallet.label')}><small>{t('room.balanceLabel')}</small><strong>{money(wallet.balanceMinor,wallet.currency)}</strong></div>
  <RoomMenu onSelect={onNavigate} sound={sound} onSound={()=>onSound(!sound)}/>
 </header>;
}

export function RoomMasthead({state,broadcast,sound,onBroadcast,onSound,sticky}:{state:Snapshot;broadcast:boolean;sound:boolean;onBroadcast:()=>void;onSound:(sound:boolean)=>void;sticky:boolean}){
 const ref=useRef<HTMLDivElement>(null);
 useLayoutEffect(()=>{
  const element=ref.current;if(!element||!sticky)return;
  const root=document.documentElement;
  const update=()=>root.style.setProperty('--room-sticky-height',element.getBoundingClientRect().height+'px');
  root.classList.add('tombala-sticky-active');update();
  // Geometry only: no scroll listener, extra game subscription or per-ball measurement.
  const observer=new ResizeObserver(update);observer.observe(element);
  return()=>{observer.disconnect();root.classList.remove('tombala-sticky-active');root.style.removeProperty('--room-sticky-height');};
 },[sticky]);
 return <div ref={ref} className="room-sticky" data-sticky={sticky}>
  {/* The main broadcast stays full-size across draw phases; only PurchaseScene uses compact media. */}
  <LiveScene state={state} broadcast={broadcast} sound={sound} onSoundChange={onSound} controls={<RoomControls broadcast={broadcast} onBroadcast={onBroadcast} sound={sound} onSound={()=>onSound(!sound)}/>}/>
  <PurchasePrizeGuide state={state}/>
 </div>;
}
